/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';
import Navbar from '@trdk/style/NavBar';
import { MuiThemeProvider, makeStyles } from '@material-ui/core/styles';
import Theme from '@trdk/style/Theme';
import CssBaseline from '@material-ui/core/CssBaseline';
import Splash from '@trdk/style/Splash';
import { Typography } from '@material-ui/core';
import SendFiles from './pages/send-digibarn-files';
import NotFound from './pages/not-found';
import PageContainer from './components/page-container';
import ErrorPage from './pages/error-page';
import authFetch from './services/authFetch';
import calculateFetchPath from './services/calculateFetchPath';

const routes = {
  '/': {
    component: SendFiles,
  },
};

const App = () => {
  const classes = useStyles();

  const [authenticationError, setAuthenticationError] = useState('');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  useEffect(() => {
    authFetch(calculateFetchPath('/gap/modulusbarn/v1/auth'))
      .then(async (res) => {
        if (res.ok) {
          const jsonRes = await res.json();
          setIsAuthenticated(jsonRes.isAuthenticated);
        } else if (res.status === 403) {
          setAuthenticationError('forbidden');
        } else {
          setAuthenticationError(`Ukjent respons fra /auth: ${res.statusText}`);
        }
      })
      .catch((e) => {
        setAuthenticationError(`Ukjent feil oppsto under autorisering: ${e}`);
      });
  }, []);

  const isProfileFetchError = false;
  const noAccess = false;

  if (!isAuthenticated) {
    return (
      <MuiThemeProvider theme={Theme}>
        <Splash />
      </MuiThemeProvider>
    );
  }

  return (
    <HashRouter basename="/">
      <MuiThemeProvider theme={Theme}>
        <CssBaseline />
        <Navbar variant="styled"></Navbar>
        <PageContainer>
          {isProfileFetchError && (
            <ErrorPage
              title="Det oppstod en feil"
              className={classes.mt}
              text={
                <Typography variant="body1">
                  Det oppsto en feil ved henting av din profil. Vennligst prøv igjen, eller kontakt
                  IT-tjenesten.
                </Typography>
              }
            />
          )}
          {!isAuthenticated && (
            <ErrorPage
              title="Ikke tilgang"
              className={classes.mt}
              text={
                <Typography variant="body1">
                  Du har ikke tilgang til denne tjenesten. Dersom du skal ha tilgang, ta kontakt med
                  IT-tjenesten.
                </Typography>
              }
            />
          )}
          {authenticationError && (
            <ErrorPage
              title="Feil oppsto"
              className={classes.mt}
              text={
                <>
                  <Typography variant="body1">
                    En feil oppsto under tilgangssjekken, vennligst prøv igjen senere. Hvis
                    problemet vedvarer ta kontakt med IT-tjenesten.
                  </Typography>
                  <Typography variant="body1">{`Feilmelding: ${authenticationError}`}</Typography>
                </>
              }
            />
          )}

          {!isProfileFetchError && !noAccess && (
            <Switch>
              {Object.keys(routes).map((path) => (
                <Route key={path} path={path} exact component={routes[path].component} />
              ))}
              <Route component={NotFound} />
            </Switch>
          )}
        </PageContainer>
      </MuiThemeProvider>
    </HashRouter>
  );
};

const useStyles = makeStyles({
  mt: {
    marginTop: '2rem',
  },
  profile: {
    width: '100%',
    margin: 'auto',
    display: 'flex',
    maxWidth: '81.3rem',
    justifyContent: 'space-between',
  },
  profiledetail: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '1.3rem',
  },
});

export default App;
